@if (timeoutRequest()) {
  <app-timeout></app-timeout>
} @else if (requestStarted()) {
  <div class="flex h-full justify-content-center align-items-center">
    <p-progressSpinner ariaLabel="loading" class="customProgressSpinner" />
  </div>
} @else {
  @if (form) {
    <div [formGroup]="form" class="modalForm" style="grid-auto-flow: dense">
      <div class="flex flex-column gap-2 mb-3">
        <label for="label" class="font-semibold w-full"
          >{{ "gate_administration.building_form.label" | translate }}*</label
        >
        <input pInputText id="label" formControlName="label" autocomplete="off" />
      </div>
      <div class="flex flex-column gap-2 mb-3">
        <label for="email" class="font-semibold w-full">{{
          "gate_administration.building_form.email" | translate
        }}</label>
        <input pInputText id="email" formControlName="email" autocomplete="off" />
      </div>
      @if (building.location && building.location.locationFloorMapUrl) {
        <div style="grid-column: 1 / 3" class="flex flex-column gap-2 mb-3 floorMapContainer">
          <span class="font-semibold">{{ "gate_administration.building_form.position" | translate }}</span>
          <div class="floorMap" (click)="onImageClick($event)">
            <img [src]="floorMapSource" (load)="onImageLoad($event)" id="locationFloorMap" alt="Floor Map" />
            @if (point()) {
              <div class="point" [ngStyle]="getPointCoordinates()"></div>
            }
          </div>
        </div>
      } @else {
        <div style="grid-column: 1 / 3" class="flex flex-column gap-2 mb-3">
          <span class="font-semibold">{{ "gate_administration.building_form.position" | translate }}</span>
          <div class="modalWindowMap" id="buildingMapContainer"></div>
        </div>
      }

      <div
        class="flex flex-column gap-2 mb-3"
        *appHasPermission="{
          permissions: [permissions.allPermissions.MEDIA_CREATE, permissions.allPermissions.MEDIA_UPDATE],
        }"
      >
        <label for="floorMap" class="font-semibold w-full">{{
          "gate_administration.building_form.floor_map" | translate
        }}</label>
        <div id="floorMap" class="flex align-items-center justify-content-between">
          @if (building.floorMapUrl) {
            <a [href]="building.floorMapUrl" target="_blank">{{
              "gate_administration.building_form.open_floor_map" | translate
            }}</a>
          } @else if (!selectedFloorMap) {
            <span>{{ "gate_administration.building_form.no_floor_map" | translate }}</span>
          }
          <p-fileUpload
            #fileUpload
            (click)="onFileUploadClick(fileUpload)"
            (onSelect)="onFileSelect($event)"
            [chooseLabel]="translate.instant('common.choose_file')"
            [showUploadButton]="false"
            [showCancelButton]="false"
            class="w-full"
            styleClass="customFileUpload"
            name="file"
            accept="image/*,application/pdf"
            maxFileSize="10000000"
          >
            <ng-template #content let-uploadedFiles>
              @if (uploadedFiles.length > 0) {
                {{ uploadedFiles.length }}
                {{ "common.files_selected" | translate }}
              }
            </ng-template>
          </p-fileUpload>
        </div>
      </div>
      <div class="flex flex-column gap-2 mb-3">
        <label for="phone" class="font-semibold w-full">{{
          "gate_administration.building_form.phone" | translate
        }}</label>
        <input pInputText id="phone" formControlName="phone" autocomplete="off" />
      </div>
      <ng-container formGroupName="address">
        <div class="flex flex-column gap-2 mb-3">
          <label for="street" class="font-semibold w-full">{{ "common.address.street" | translate }}</label>
          <input pInputText id="street" formControlName="street" autocomplete="off" />
        </div>
        <div class="flex flex-column gap-2 mb-3">
          <label for="number" class="font-semibold w-full">{{ "common.address.number" | translate }}</label>
          <input pInputText id="number" formControlName="number" autocomplete="off" />
        </div>
        <div class="flex flex-column gap-2 mb-3">
          <label for="zipCode" class="font-semibold w-full">{{ "common.address.zipCode" | translate }}</label>
          <input pInputText id="zipCode" formControlName="zipCode" autocomplete="off" />
        </div>
        <div class="flex flex-column gap-2 mb-3">
          <label for="city" class="font-semibold w-full">{{ "common.address.city" | translate }}</label>
          <input pInputText id="city" formControlName="city" autocomplete="off" />
        </div>
      </ng-container>
      <div class="flex flex-column gap-2 mb-3">
        <label for="length" class="font-semibold w-full">{{
          "gate_administration.building_form.length" | translate
        }}</label>
        <p-inputNumber
          class="w-full"
          id="length"
          formControlName="length"
          (onInput)="sizeChange()"
          mode="decimal"
          minFractionDigits="0"
          maxFractionDigits="4"
        />
      </div>
      <div class="flex flex-column gap-2 mb-3">
        <label for="width" class="font-semibold w-full">{{
          "gate_administration.building_form.width" | translate
        }}</label>
        <p-inputNumber
          class="w-full"
          id="width"
          formControlName="width"
          (onInput)="sizeChange()"
          mode="decimal"
          minFractionDigits="0"
          maxFractionDigits="4"
        />
      </div>
      <div class="flex flex-column gap-2 mb-3">
        <label for="height" class="font-semibold w-full">{{
          "gate_administration.building_form.height" | translate
        }}</label>
        <p-inputNumber
          class="w-full"
          id="height"
          formControlName="height"
          (onInput)="sizeChange()"
          mode="decimal"
          minFractionDigits="0"
          maxFractionDigits="4"
        />
      </div>
      <div class="flex flex-column gap-2 mb-3">
        <label for="surface" class="font-semibold w-full">{{
          "gate_administration.building_form.surface" | translate
        }}</label>
        <p-inputNumber class="w-full" formControlName="surface" id="surface" readonly="true" />
      </div>
      <div class="flex flex-column gap-2 mb-3">
        <label for="volume" class="font-semibold w-full">{{
          "gate_administration.building_form.volume" | translate
        }}</label>
        <p-inputNumber class="w-full" formControlName="volume" id="volume" readonly="true" />
      </div>
      <ng-container formGroupName="address">
        <div class="flex flex-column gap-2 mb-3">
          <label for="country" class="font-semibold w-full">{{ "common.address.country" | translate }}</label>
          <p-select id="country" formControlName="country" [options]="countries" class="w-full">
            <ng-template let-country #selectedItem>
              {{ country.label | translate }}
            </ng-template>
            <ng-template let-country #item>
              {{ country.label | translate }}
            </ng-template>
          </p-select>
        </div>
      </ng-container>
      <div class="flex flex-column gap-2 mb-3">
        <label for="climateType" class="font-semibold w-full"
          >{{ "gate_administration.building_form.climateType" | translate }} *</label
        >
        <p-select
          id="climateType"
          formControlName="climateType"
          [options]="climateTypeOptions"
          optionLabel="label"
          optionValue="value"
          class="w-full"
        />
      </div>
      <div class="flex flex-column gap-2 mb-3">
        <label for="energyCost" class="font-semibold w-full">{{
          "gate_administration.building_form.energyCost" | translate
        }}</label>
        <input pInputText id="energyCost" formControlName="energyCost" autocomplete="off" type="number" />
      </div>
      <div class="flex flex-column gap-2 mb-3">
        <label for="totalGates" class="font-semibold w-full">{{
          "gate_administration.building_form.totalGates" | translate
        }}</label>
        <input pInputText id="totalGates" formControlName="totalGates" autocomplete="off" type="number" min="0" />
      </div>
      <div class="flex flex-column gap-2 mb-3">
        <label for="totalGateSurface" class="font-semibold w-full">{{
          "gate_administration.building_form.totalGateSurface" | translate
        }}</label>
        <input pInputText id="totalGateSurface" formControlName="totalGateSurface" autocomplete="off" type="number" />
      </div>
      <ng-container formGroupName="techEmployee">
        <div class="flex flex-column gap-2 mb-3 g-col-1">
          <label for="techEmployeeName" class="font-semibold w-full">{{
            "gate_administration.building_form.techEmployee" | translate
          }}</label>

          <input pInputText id="techEmployeeName" formControlName="name" autocomplete="off" />
        </div>
        <div class="flex flex-column gap-2 mb-3 g-col-1">
          <label for="techEmployeeEmail" class="font-semibold w-full">{{
            "gate_administration.building_form.email" | translate
          }}</label>
          <input pInputText id="techEmployeeEmail" formControlName="email" autocomplete="off" />
        </div>
        <div class="flex flex-column gap-2 mb-3 g-col-1">
          <label for="techEmployeePhone" class="font-semibold w-full">{{
            "gate_administration.building_form.phone" | translate
          }}</label>
          <input pInputText id="techEmployeePhone" formControlName="phone" autocomplete="off" />
        </div>
      </ng-container>
      <ng-container formGroupName="ecoEmployee">
        <div class="flex flex-column gap-2 mb-3 g-col-2">
          <label for="ecoEmployeeName" class="font-semibold w-full">{{
            "gate_administration.building_form.ecoEmployee" | translate
          }}</label>
          <input pInputText id="ecoEmployeeName" formControlName="name" autocomplete="off" />
        </div>
        <div class="flex flex-column gap-2 mb-3 g-col-2">
          <label for="ecoEmployeeEmail" class="font-semibold w-full">{{
            "gate_administration.building_form.email" | translate
          }}</label>
          <input pInputText id="ecoEmployeeEmail" formControlName="email" autocomplete="off" />
        </div>
        <div class="flex flex-column gap-2 mb-3 g-col-2">
          <label for="ecoEmployeePhone" class="font-semibold w-full">{{
            "gate_administration.building_form.phone" | translate
          }}</label>
          <input pInputText id="ecoEmployeePhone" formControlName="phone" autocomplete="off" />
        </div>
      </ng-container>

      <div style="grid-column: 1/3" class="flex flex-column gap-2 mb-3">
        <label for="notes" class="font-semibold w-full">{{
          "gate_administration.building_form.notes" | translate
        }}</label>
        <textarea rows="5" cols="30" pInputTextarea formControlName="notes" [autoResize]="true" id="notes"></textarea>
      </div>
      <div class="flex justify-content-end gap-2 dialogBtnGroup" style="grid-column: 1/3">
        <app-button id="cancelBuildingButton" buttonText="common.cancel" (click)="closeDialog()"></app-button>
        <app-button
          buttonText="common.save"
          [disabled]="!form.valid || requestStarted()"
          (click)="save()"
          [loading]="requestStarted()"
        ></app-button>
      </div>
    </div>
  }
}
